interface SectionHeaderProps {
  title: string;
}

export function SectionHeader({ title }: SectionHeaderProps) {
  return (
    <div className='mb-6 mt-8 flex items-center gap-4'>
      <h2 className='text-sm font-medium uppercase tracking-wide text-slate-600'>
        {title}
      </h2>
      <div className='h-px flex-1 bg-slate-200' />
    </div>
  );
}
